import * as storage from '~/utils/storage';

interface UserCredential {
  user?: any;
  accessToken?: string | null;
  userType?: string | null;
}

interface GoogleUserInfo {
  accessToken?: string;
  user?: any;
}

export const authWithGoogle = async () => {
  // try {
  //   const resp = await request.get(API_URL.GET_GOOGLE_AUTH_URL)
  //   const googleAuthURL = resp.data.data.url
  //   window.location = googleAuthURL
  // } catch (e) {
  //   new AppError(e, 'Cannot login using google. Please try again')
  // }
};

export const removeSavedUserInfo = () => {
  storage.remove('ELEVATE_ADMIN_ACCESS_TOKEN');
  storage.remove('EASE_ADMIN_USER');
  storage.remove('EASE_ADMIN_USER_TYPE');
};

export const saveUserCredential = async ({accessToken, user, userType}: UserCredential) => {
  if (accessToken) {
    await storage.save('ELEVATE_ADMIN_ACCESS_TOKEN', accessToken);
  }
  if (user) {
    await storage.save('EASE_ADMIN_USER', user);
  }
  if (userType) {
    await storage.save('EASE_ADMIN_USER_TYPE', userType);
  }
};

export const getCurrentUserFromStorage = (): UserCredential => {
  const user = storage.load('EASE_ADMIN_USER');
  const accessToken = storage.load('ELEVATE_ADMIN_ACCESS_TOKEN');
  const userType = storage.load('EASE_ADMIN_USER_TYPE');

  return {
    accessToken,
    user,
    userType,
  };
};
